import moment from "moment";

export const formatEvents = (events) => {
  return events.map((event) => ({
    id: crypto.randomUUID(), // Unique fallback ID for calendar
    ...(event.type === "event" && { event_id: event.id }),
    ...(event.type === "task" && { task_id: event.id }),
    task_master_id: event?.task_master_id || null,
    event_master_id: event?.event_master_id || null,
    title: event?.title || "Untitled Event",
    assigned_by: event?.assigned_by,
    location: event?.location,
    progress_status_id: event?.progress_status_id || null,
    priority_id: event?.priority_id || null,
    display_name_id: event?.display_name_id || null,
    description: event?.description,
    start: event?.start_time
      ? moment(event.start_time).format("YYYY-MM-DDTHH:mm:ss")
      : null,
    occurrenceDate: moment.utc(event.start_time).format("YYYY-MM-DD"),
    end: event?.end_time
      ? moment(event.end_time).format("YYYY-MM-DDTHH:mm:ss")
      : null,
    reminder: event?.reminder_timestamp || null,
    createdBy: event?.created_by,
    updatedBy: event?.updated_by,
    type: event?.type,
    displaynameId: event?.display_name_id,
    priorityId: event?.priority_id || null,
    progressStatusId: event?.progress_status_id || null,
    checklists: Array.isArray(event?.checklists) ? event.checklists : [],
    color_id: Number(event?.color_id ?? null), // Default color
    assignees: event?.assignees || [],
    collaborators: event?.collaborators || [],
    repeat_option: event?.repeat_option,
    repetition_end_date: event?.repetition_end_date,
    exclude_saturdays: event?.exclude_saturdays,
    exclude_sundays: event?.exclude_sundays,
    include_weekends: event?.include_weekends,
    included_weekend_days: event?.included_weekend_days,
    adjust_weekends: event?.adjust_weekends,
  }));
};
